import { render } from "./import-list.vue?vue&type=template&id=388ce457&scoped=true"
import script from "./import-list.vue?vue&type=script&lang=js"
export * from "./import-list.vue?vue&type=script&lang=js"

import "./import-list.vue?vue&type=style&index=0&id=388ce457&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388ce457"]])

export default __exports__